/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
import 'typeface-montserrat'
import 'typeface-lato'

import './styles/css/reset.css'
import './styles/sass/global/styles.scss'
